(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/matchen/assets/javascripts/views/coupon-header.js') >= 0) return;  svs.modules.push('/modules/matchen/assets/javascripts/views/coupon-header.js');

'use strict';

const {
  SportinfoPathNames
} = svs.components.sportinfo.common.constants;
svs.matchen.views.CouponHeader = Marionette.View.extend({
  className: 'event-name padding-1 bg-oddset-500 align-center fc-white f-bold js-event-name',
  events: {
    click: 'onClick'
  },
  onClick() {
    if (svs.core.detect.formfactor.mobile() && this.options.hasMatchInfoTabs()) {
      const drawNumber = this.model.get('drawNumber');
      const eventDescription = svs.utils.url.encode(this.model.get('eventDescription'));
      const description = svs.utils.url.encode(this.model.get('description'));
      Backbone.history.navigate("/spela/".concat(drawNumber, "-").concat(eventDescription, "-").concat(description, "/").concat(SportinfoPathNames.MatchInfo), {
        trigger: true,
        replace: false
      });
    }
  },
  template(data) {
    return svs.matchen.templates.coupon_header(data);
  }
});

 })(window);